import BaseComponent from 'base-component';
import KaistoreHawkHelper from 'kaistore-hawk-helper/lib';

const mapDownloadErrorsToLoggerStatus = {
  NETWORK_ERROR: 0,
  DOWNLOAD_ERROR: 101,
  CHECK_DEPENDENCIES_ERROR: 108,
  INSUFFICIENT_STORAGE: 104
};

export const bookmarkEvent = {
  OPEN: 'store_bm_open',
  PIN: 'store_bm_pin'
};

class LoggerHelper extends BaseComponent {
  constructor() {
    super();
    this.apiName = 'events';
  }

  postData(data) {
    let apiUri = deviceInfos.get('apps.serviceCenterUrl');
    let url = apiUri + '/' + this.apiName;
    return new Promise((resolve, reject) => {
      let requester = KaistoreHawkHelper.getRequester({
        serverTimeOffset: window.serverTimeOffset,
        deviceInfos: window.deviceInfos,
        setDeviceInfo: true,
        useCustomConnectionType: true
      });
      requester
        .send({
          url: url,
          method: 'POST',
          params: data
        })
        .then(
          response => {
            resolve(JSON.parse(response));
          },
          error => {
            console.error('logger:' + error.statusText);
            reject();
          }
        );
    });
  }

  postAppInstallData(appsInfo, error = null) {
    let logsInfo = {
      event_type: 'store_app_install'
    };
    logsInfo = Object.assign(appsInfo, logsInfo);
    if (error === null) {
      logsInfo.status_code = 1;
    } else {
      logsInfo.status_code = this._getInstallErrorStatus(error);
    }
    this.postData(logsInfo);
  }

  postAppViewData(activeApp, appOrder = null, adId = null) {
    let logsInfo = {
      event_type: 'store_app_view',
      app_id: activeApp.id,
      app_version: activeApp.info.version,
      app_name: activeApp.info.localized.name,
      tab_code: activeApp.remoteInfo.category.toString()
    };
    if (appOrder !== null) {
      logsInfo.app_order = parseInt(appOrder, 10);
    }
    if (adId !== null) {
      logsInfo.ad_id = adId;
    }
    this.postData(logsInfo);
  }

  postBookmarkData(eventType, id, info) {
    const { localized, version } = info;
    const data = {
      event_type: eventType,
      app_version: version,
      app_id: id,
      app_name: localized.name
    };
    this.postData(data);
  }

  _getInstallErrorStatus(message) {
    const status = mapDownloadErrorsToLoggerStatus[message];
    if (typeof status !== 'undefined') {
      return status;
    } else {
      return 101;
    }
  }
}
export const loggerHelper = new LoggerHelper();



/** WEBPACK FOOTER **
 ** ./src/helper/logger-helper.js
 **/